import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import DNDPreviewLayerComponent from "core/gd-modules/dnd/preview-layer/dnd-preview-layer-component";
import ListHeaderSortButton from "../sort/sort-button";

export default class GenericListHeaderPreviewLayer extends DNDPreviewLayerComponent {

    static propTypes = {
        module: PropTypes.object
    }

    showPreview(source, mouseEvent) {
        this.initialPreviewSourceRect = source.getInitialRect();

        this.setState({
            source: source
        }, ()=>{
            this.onItemUpdate();
        });
    }

    onItemUpdate = () => {
        this.previewNode = findDOMNode(this.preview);
        this.updatePreview();
    }

    hidePreview() {
        this.initialPreviewSourceRect = null;
        this.previewNode = null;

        this.setState({
            source: null
        });
    }

    updatePreview(dx = 0, dy = 0) {
        if (!this.initialPreviewSourceRect) return;

        this.previewNode.style.setProperty("left", (this.initialPreviewSourceRect.left + dx) + "px");
        this.previewNode.style.setProperty("top", (this.initialPreviewSourceRect.top/* + dy*/) + "px");
    }

    renderItem() {
        const column = this.state.source.props.column;
        return (
            <div ref={r=>this.preview = r} className="glist-row glist-header">
                <div className={Classes("cell can-resize is-preview", column.alignment)} style={{width:this.state.source.props.column.width}}>
                    <div className="dnd-handle">
                        <div className="dnd-icon ui5-ico-16 ui5-icon-dnd"/>
                    </div>
                    <div className="label">{this.props.module.fields.get(column.fieldId).label}</div>

                    {this.props.module.canSort &&
                        <ListHeaderSortButton module={this.props.module} fieldId={column.fieldId}/>}

                    <div className="gd-popup-menu-btn more-icon gd-ui-more ui5-ico-more s20 hover-action"></div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.source) return null;

        return (
            <div className="ui5-glist-header-preview-layer">
                {this.renderItem()}
            </div>
        );
    }
}
